import { isNil, type Nil } from "@mcwd/typescript-type-guards";
import { GatingLevel, type GatingLevelFor } from "../../types/definitions/gating/gating-level.js";
import type { IFormSettings } from "../../form-settings/form-settings-factory.js";
import { getHighestPriorityGatingLevel } from "./priority/get-highest-priority-gating-level.js";
import type { AnyFormSettingsKey } from "../../form-settings/form-experience/form-settings-keys.js";
import type { FormOrFormExperienceType } from "./FormOrFormExperienceType.js";



export function getGatingLevelFromInitParameter<TFormOrExperience extends FormOrFormExperienceType>(
  type: TFormOrExperience,
  formSettingsKey: AnyFormSettingsKey,
  settings: IFormSettings,
  gatingLevelCustom?: GatingLevel.FormExperience
): GatingLevelFor<TFormOrExperience> | Nil
{
  type ThisReturnType = ReturnType<typeof getGatingLevelFromInitParameter<TFormOrExperience>>;
  if (isNil(gatingLevelCustom)){
    return null;
  }
  if (settings.gateLevelSource.includes("InitParameter")) {
    if (settings.allowedGatingStates.includes(gatingLevelCustom)) {
      if (gatingLevelCustom === "NoGate" && type === "MarketoForm") {
        const highestSettingsLevel = getHighestPriorityGatingLevel(type, settings.allowedGatingStates) as ThisReturnType;
        if (isNil(highestSettingsLevel)){
          throw new Error(`Property 'allowedGatingStates' for formSettingsKey "${ settings.formSettingsKey }" does not contain a valid GatingLevel value`);
        }
        return highestSettingsLevel;
      }
      return gatingLevelCustom as ThisReturnType;
    }
    const allowedValuesStr = settings.allowedGatingStates.map(s => `"${s}"`).join(", ");
    throw new Error(`Form init parameter 'gatingLevelCustom' contains the value '${gatingLevelCustom}' which is not a valid gating level for formSettingsKey '${formSettingsKey}' which expects on of the following: ${allowedValuesStr}`);
  }
  throw new Error(`Form init parameter 'gatingLevelCustom' is not allowed for formSettingsKey '${formSettingsKey}' because the associated form experience settings do NOT contain "InitParameter" in the "gateLevelSource" array property.`);
}
